
jQuery(document).ready(function($) {
    
    $('.woocommerce-product-gallery iframe').css('height', '100%');
    $('.woocommerce-product-gallery iframe').css('width', '100%');

    // Handle the click event of your link
    $('.scl-ajax-free-buy').on('click', function(e) {
        e.preventDefault();

        // Get the product ID from a data attribute or any other source
        let productId = $(this).data('product-id');
        let link = $(this);
        // Make the AJAX request
        $.ajax({
            url: sclAjax.ajaxurl,
            type: 'POST',
            data: {
                action: 'scl_ajax_free_buy',
                product_id: productId, // Pass the product ID
                // Add any additional data you need to send
            },
            success: function(response) {
                // Handle the AJAX response
              
                // Create a new text element with the product ID
                var text = document.createTextNode(response.message);
            
                // Replace the link with the new text element
                link.replaceWith(response.message);
            },
            error: function(xhr, status, error) {
                // Handle AJAX error
                console.log(error);
            }
        });
    });
});